export default __webpack_public_path__ + "static/media/logo.98b360a1.png";